module.exports = __webpack_public_path__ + "static/media/icc_patjar_istimewa.bcc209c6.png";